import useQuery from '../../../../../shared/hooks/useQuery';
import { EmailTemplate } from '../../../../../../types/internal-api';

export function useEmailTemplates(documentType: number | undefined) {
    const skip = !documentType || documentType < 1;

    const { loading, ...rest } = useQuery<EmailTemplate[]>(`setup/email-templates/${documentType}`, [], { skip });

    return {
        ...rest,
        loading: loading && !skip,
    };
}
